/**
 * Ürün/kategori ağacı seçici ve TR uyumlu katlanmış arama (Servis kaydı + müşteri cihaz ortak)
 */

import {
  normalizeForSearch as foldSearch,
  searchTokens as foldedSearchTokens,
} from './searchHelpers';

export { foldSearch, foldedSearchTokens };

export const productMatchesFoldedTokens = (u, tokens) => {
  if (!tokens.length) return true;
  const hay = foldSearch(
    [
      u.icerikAdi,
      u.urunAdi,
      u.icerikKodu,
      u.urunKodu,
      u.malKodu,
      u.modelKodu,
    ]
      .filter((x) => x != null && String(x).trim() !== '')
      .join(' ')
  );
  return tokens.every((t) => hay.includes(t));
};

export function buildProductCategoryTree(flat) {
  const list = (flat || []).map((c) => ({
    ...c,
    cid: String(c.id || c._id),
    children: [],
  }));
  const byId = new Map(list.map((cnt) => [cnt.cid, cnt]));
  const roots = [];
  for (const c of list) {
    const pid = c.ustKategoriId ? String(c.ustKategoriId) : '';
    if (pid && byId.has(pid)) byId.get(pid).children.push(c);
    else roots.push(c);
  }
  const sortCh = (a, b) =>
    (a.kategoriSirasi ?? 0) - (b.kategoriSirasi ?? 0) ||
    String(a.kategoriAdi || '').localeCompare(String(b.kategoriAdi || ''), 'tr', {
      sensitivity: 'base',
    });
  const walk = (nodes) => {
    nodes.sort(sortCh);
    nodes.forEach((n) => walk(n.children));
  };
  walk(roots);
  return roots;
}

export function annotateProductCategoryAcc(node, productsByCatId) {
  const id = node.cid;
  const products = productsByCatId.get(id) || [];
  const children = (node.children || []).map((ch) => annotateProductCategoryAcc(ch, productsByCatId));
  const visible = products.length > 0 || children.some((c) => c.visible);
  return {
    cid: id,
    kategoriAdi: node.kategoriAdi,
    kategoriSirasi: node.kategoriSirasi,
    children,
    visible,
    products,
  };
}
